module.exports = __webpack_public_path__ + "img/background.1c9d1201.png";